import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { CalendarDays, ExternalLink } from "lucide-react";
import Comments from "@/components/Comments";

export default function Scholarships() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [jenjang, setJenjang] = useState("ALL");

  const load = async () => {
    const { data } = await http.get("/scholarships", { params: { jenjang, q } });
    setItems(data);
  };
  useEffect(() => { load(); }, [jenjang]); // eslint-disable-line

  return (
    <div>
      <p className="text-xs uppercase tracking-widest text-[#D97706] font-semibold">Beasiswa</p>
      <h1 className="serif text-3xl font-bold text-[#0F2922] mt-1">Portal Beasiswa S1 · S2 · S3</h1>
      <p className="text-slate-600 mt-2">Kurasi beasiswa dalam & luar negeri dengan link resmi.</p>

      <div className="mt-6 flex flex-wrap gap-3">
        <Input placeholder="Cari beasiswa…" value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")load();}} className="max-w-sm" data-testid="scholarship-search-input" />
        <Select value={jenjang} onValueChange={setJenjang}>
          <SelectTrigger className="w-40" data-testid="scholarship-filter-jenjang"><SelectValue placeholder="Jenjang" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">Semua Jenjang</SelectItem>
            <SelectItem value="S1">S1</SelectItem>
            <SelectItem value="S2">S2</SelectItem>
            <SelectItem value="S3">S3</SelectItem>
          </SelectContent>
        </Select>
        <Button onClick={load} className="bg-[#0F2922] hover:bg-[#173E34] text-[#FAFA96]" data-testid="scholarship-search-btn">Cari</Button>
      </div>

      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {items.map(s => (
          <div key={s.id} className="kt-card p-5" data-testid="scholarship-card-item">
            <div className="flex items-start justify-between gap-3">
              <div>
                <h3 className="text-lg font-semibold text-[#0F2922]">{s.name}</h3>
                <p className="text-xs text-slate-500 mt-0.5">{s.provider}</p>
              </div>
              <div className="flex gap-1 flex-wrap justify-end">
                {s.jenjang.map(j => <Badge key={j} className="bg-[#0F2922] text-[#FAFA96]">{j}</Badge>)}
              </div>
            </div>
            <div className="mt-3 flex flex-wrap gap-2 text-xs">
              <Badge variant="outline" className="border-[#D97706] text-[#D97706]">{s.jenis}</Badge>
              <Badge variant="outline">{s.region}</Badge>
              <span className="inline-flex items-center gap-1 text-slate-500"><CalendarDays size={12}/> Deadline: {s.deadline}</span>
            </div>
            <p className="mt-3 text-sm text-slate-700"><b>Benefit:</b> {s.amount}</p>
            <div className="mt-2 text-xs text-slate-600">
              <b>Syarat:</b>
              <ul className="list-disc pl-5 mt-1 space-y-0.5">
                {s.requirements.map((r,i)=><li key={i}>{r}</li>)}
              </ul>
            </div>
            <a href={s.url} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#D97706] hover:underline" data-testid="scholarship-link">
              Kunjungi situs resmi <ExternalLink size={14}/>
            </a>
            <Comments contentType="scholarship" contentId={s.id} />
          </div>
        ))}
      </div>
    </div>
  );
}
